import { BrowserRouter, Route, Routes, Navigate } from 'react-router';
import { useBootState, useMe } from './api/hooks.ts';
import { AppShell } from './components/AppShell.tsx';
import { Home } from './pages/Home.tsx';
import { Chart } from './pages/Chart.tsx';
import { Stats } from './pages/Stats.tsx';
import { Settings } from './pages/Settings.tsx';
import { Family } from './pages/Family.tsx';
import { Login } from './pages/Login.tsx';
import { AcceptInvite } from './pages/AcceptInvite.tsx';
import { Bootstrap } from './pages/Bootstrap.tsx';
import { More } from './pages/More.tsx';
import { Onboarding } from './pages/Onboarding.tsx';
import { Events } from './pages/Events.tsx';
import { Growth } from './pages/Growth.tsx';
import { Health } from './pages/Health.tsx';
import { Milestones } from './pages/Milestones.tsx';
import { Monitor } from './pages/Monitor.tsx';

function Authed({ children }: { children: React.ReactNode }) {
  // Fire the cold-start aggregator — populates /me and seeds the cache for
  // measurements/milestones/medications in one round-trip. The downstream
  // useMe() will be a cache hit once `state` resolves.
  useBootState();
  const { data, isLoading, error } = useMe();
  if (isLoading) return <div className="lt-loading" />;
  if (error || !data) return <Navigate to="/login" replace />;
  return <AppShell me={data}>{children}</AppShell>;
}

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/i/:token" element={<AcceptInvite />} />
        <Route path="/claim/:token" element={<Bootstrap />} />
        <Route path="/onboarding" element={<Onboarding />} />

        <Route path="/" element={<Authed><Home /></Authed>} />
        <Route path="/chart" element={<Authed><Chart /></Authed>} />
        <Route path="/stats" element={<Authed><Stats /></Authed>} />
        <Route path="/stats/:tab" element={<Authed><Stats /></Authed>} />
        <Route path="/more" element={<Authed><More /></Authed>} />
        <Route path="/events" element={<Authed><Events /></Authed>} />
        <Route path="/today" element={<Authed><Events /></Authed>} />
        <Route path="/growth" element={<Authed><Growth /></Authed>} />
        <Route path="/milestones" element={<Authed><Milestones /></Authed>} />
        <Route path="/health" element={<Authed><Health /></Authed>} />
        <Route path="/family" element={<Authed><Family /></Authed>} />
        <Route path="/babies" element={<Navigate to="/family" replace />} />
        <Route path="/settings" element={<Authed><Settings /></Authed>} />
        <Route path="/monitor" element={<Authed><Monitor /></Authed>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
